<template>
  <info-block
    :toggable="false"
    class="info-block--schedule info-block--border"
  >
    <div class="info-block__head">
      <div class="info-block__header">
        <i class="info-block__marker" style="background: #A42AC3;"></i>
        <div class="info-block__header-wrapper">
          <div class="info-block__title">
            <span>{{ $t('students.schedule') }}</span>
          </div>
        </div>
      </div>
      <div class="schedule-title">{{ $t('students.schedule_show_setting') }}</div>
      <div class="schedule-buttons">
        <button
          class="schedule-button"
          :class="{'isActive': isList}"
          @click.prevent="$emit('makeList', true)"
        >
          {{ $t('labels.list')}}
        </button>
        <button
          class="schedule-button"
          :class="{'isActive': !isList}"
          @click.prevent="$emit('makeList', false)"
        >
          {{ $t('labels.day')}}
        </button>
      </div>
    </div>
    <div class="info-block__container">
      <div class="info-block__content">
        <div class="schedule-days">
          <template v-if="Object.keys(scheduleInner).length">
            <transition-group name="list" tag="div">
              <div
                v-if="index < maxGroups"
                v-for="(day, date, index) of scheduleInner"
                :key="date"
                class="schedule-day"
              >
                <div class="schedule-day-title">{{ date }}</div>
                <div
                  class="schedule-day-body"
                  :class="{'noPadding': day.length === 0}"
                >
                  <div
                    v-if="day.length === 0"
                    class="schedule-event-category isEmpty"
                  >
                    {{ $t('students.no_event') }}
                  </div>
                  <div
                    v-for="event in day"
                    :key="event.id"
                    class="schedule-event"
                    :class="eventClasses(event)"
                  >
                    <div class="schedule-event-header">
                      <div class="schedule-event-time">{{ getTime(event) }}</div>
                      <div
                        v-if="event.is_important"
                        class="schedule-event-notification"
                      />
                    </div>
                    <div
                      v-if="event.category || event.summary"
                      class="schedule-event-category"
                    >
                      {{ event.category }}
                      <template v-if="event.summary">— {{ event.summary }}</template>
                    </div>
                    <div
                      v-if="event.description"
                      class="schedule-event-description"
                    >
                      {{ event.description }}
                    </div>
                    <div
                      v-if="event.location"
                      class="schedule-event-location"
                    >
                      {{ event.location }}
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </template>
          <template v-else>
            <div class="schedule-day-title">{{ $t('students.no_event') }}</div>
          </template>
        </div>
        <div class="schedule-actions" v-if="hasAnotherGroup">
          <el-button
            type="primary"
            plain
            v-if="hasAnotherGroup"
            @click="$emit('addList')"
          >
            {{ $t('labels.show_more') }}
          </el-button>
        </div>
      </div>
    </div>
  </info-block>
</template>
<script>
  import store from '@/store'
  import {SCHEDULE_GROUP_NAME} from '@/constants'

  export default {
    name: 'ScheduleBlock',
    props: {
      schedule: {
        type: Object,
        required: true
      },
      isList: {
        type: Boolean,
        default: true
      },
      maxGroups: {
        type: Number
      },
      id: String
    },
    methods: {
      eventClasses (event) {
        const classes = {};
        const groupsClass = this.groupsClass(event);

        classes[groupsClass] = true;

        if (event.is_important) {
          classes.isImportant = true;
        }

        return classes;
      },
      groupsClass (group) {
        const groupKey = SCHEDULE_GROUP_NAME;
        const groups = this.userGroups;
        for (let gr in groups) {
          if (groups[gr][groupKey] === group.group_id) {
            return `isColor${+gr + 1}`;
          }
        }
      },
      getTime ({beg_ts, end_ts}) {
        const timeStart = new Date(beg_ts);
        const hourStart = timeStart.getHours();
        const minuteStart = timeStart.getMinutes();
        const timeStartText = `${hourStart < 10 ? `0${hourStart}` : hourStart}:${minuteStart < 10 ? `0${minuteStart}` : minuteStart}`;

        const timeEnd = new Date(end_ts);
        const hourEnd = timeEnd.getHours();
        const minuteEnd = timeEnd.getMinutes();
        const timeEndText = `${hourEnd < 10 ? `0${hourEnd}` : hourEnd}:${minuteEnd < 10 ? `0${minuteEnd}` : minuteEnd}`;

        return `${timeStartText}-${timeEndText}`;
      }
    },
    computed: {
      student () {
        return this.$store.state.students.students[this.id]
      },
      userGroups () {
        if (this.student && this.student.data.stud.cards) {
          return this.student.data.stud.cards;
        }
        return [];
      },
      scheduleInner () {
        if (!this.isList) {
          const onlyScheduleDate = Object.keys(this.schedule)[0];
          const onlyScheduleContent = this.schedule[Object.keys(this.schedule)[0]];
          return {
            [onlyScheduleDate]: onlyScheduleContent
          };
        }
        return this.schedule;
      },
      hasAnotherGroup () {
        return this.isList && Object.keys(this.schedule).length > this.maxGroups;
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/core';
@import 'src/assets/sass/paper/components/schedule';

.info-block--schedule {
  background: none;
  box-shadow: none;

  .info-block__content {
    padding-bottom: 0;
    padding-top: 0;
  }
  .info-block__content-container > .info-block__content {
    padding: 0 !important;
  }
  .info-block__head {
    background: #fff;
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, .02);
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-radius: 3px;
    overflow: hidden;
  }
  .info-block__content-container .info-block__container {
    border-radius: 3px;
    overflow: hidden;

    .schedule-day {
      background: #fff;
      box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, .02);
      border-radius: 3px;
    }
  }
  .schedule-title {
    padding: 20px 30px;
    margin: 0;
    @include respond-to(phone) {
     padding-left: 19px;
    }
  }
  .schedule-buttons {
    margin-left: 30px;
    margin-bottom: 0;
    @include respond-to(phone) {
     margin-left: 19px;
    }
  }
}
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 350ms;
}
.list-enter {
  opacity: 0;
  transform: translateX(0) scaleY(0.8);
}
.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}
.list-leave-active {
  position: absolute;
}
.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>